
















import { humanizeIsoTime } from 'plankton'
import { formatDate } from '@/utilities/date-formatters'

const MAX_CHARS_PER_LINE = 20

export default {
  props: {
    multiStop: { type: Object, required: true },
    isDialogMode: { type: Boolean, default: false },
    pickupStart: { type: String, default: '' },
    pickupEnd: { type: String, default: '' }
  },
  computed: {
    fromattedPickupTime() {
      const pickupTime = `${humanizeIsoTime(this.pickupStart)} - ${humanizeIsoTime(
        this.pickupEnd
      )}`
      return `${formatDate(this.pickupStart)} | ${pickupTime}`
    },
    originAddress() {
      return this.formatAddress(this.multiStop.singleStops[0].address)
    },
    originAddressTooltip() {
      return (
        this.originAddress.length > MAX_CHARS_PER_LINE &&
        this.multiStop.singleStops[0].address.locality
      )
    }
  },
  methods: {
    formatAddress({ countryCode, postalCode, locality }) {
      return `${countryCode}, ${postalCode ||
        this.$t('baseOrderColumns.emptyPostalCodePlaceholder')}, ${locality ||
        this.$t('baseOrderColumns.emptyCityPlaceholder')}`
    }
  }
}
